import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { t } from '@/lib/i18n';
import { useRemove } from '@/lib/resources';
import { Button } from './ui/button';
import { ConfirmDialog } from './ui/dialog';

/** Save / Delete buttons for an edit page. */
export function FormActions({
  saving,
  resource,
  id,
  backTo,
  canDelete = true,
  canSave = true,
  deleteMessage = t('This cannot be undone.'),
}: {
  saving: boolean;
  resource: string;
  id?: string;
  backTo: string;
  canDelete?: boolean;
  canSave?: boolean;
  deleteMessage?: string;
}) {
  const [confirm, setConfirm] = useState(false);
  const remove = useRemove(resource);
  const navigate = useNavigate();
  const isNew = !id || id === 'new';
  return (
    <div className="flex items-center justify-between gap-2 border-t border-slate-200 pt-4">
      <div>
        {!isNew && canDelete && (
          <Button
            variant="ghost"
            className="text-red-600! hover:bg-red-50"
            icon={<Trash2 className="size-4" />}
            onClick={() => setConfirm(true)}
          >
            {t('Delete')}
          </Button>
        )}
      </div>
      <div className="flex gap-2">
        <Button variant="secondary" onClick={() => navigate(backTo)}>
          {t('Cancel')}
        </Button>
        {canSave && (
          <Button type="submit" loading={saving}>
            {isNew ? t('Create') : t('Save changes')}
          </Button>
        )}
      </div>
      <ConfirmDialog
        open={confirm}
        onCancel={() => setConfirm(false)}
        title={t('Delete?')}
        message={deleteMessage}
        loading={remove.isPending}
        onConfirm={() =>
          remove.mutate(id!, {
            onSuccess: () => navigate(backTo),
            onSettled: () => setConfirm(false),
          })
        }
      />
    </div>
  );
}
